export const CSS_CLASSES = {
	CONTAINER: 'list-drawer__container',
	DRAWER: 'drawer',
	DRAWER_CLOSED: 'drawer--closed',
	DRAWER_CLOSE_ICON: 'drawer__icon--close',
	DRAWER_CONTENTS: 'drawer__contents',
	DRAWER_OPENED: 'drawer--opened',
	LIST: 'list',
	LIST_HIDDEN: 'list--hidden',
	LIST_VISIBLE: 'list--visible',
	LIST_ITEM: 'list__list-item',
	LIST_ITEM_SELECTED: 'list__list-item--selected',
};
